import React from 'react';
import styled from 'styled-components';
import KPIBox from './KPIBox';

const KPIContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px; // Space between KPI boxes
`;


function KPISection({kpis, data, filtro}) {
  return (
    <KPIContainer>
      <KPIBox label={'Taxa de Conversão'} value={`${kpis.taxaConversao.toFixed(2)} %`} />
      <KPIBox label={'Total Vendido'} value={(kpis.totalVendido || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
      <KPIBox label={'Total Vendido kwp'} value={`${kpis.totalVendidoKwp.toFixed(2)} kwp`} />
      <KPIBox label={'Ticket Médido'} value={(kpis.ticketMedio || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
      <KPIBox label={'Ticket Médido kwp'} value={`${kpis.ticketMedioKwp.toFixed(2)} kwp`} />
      <KPIBox label={'Dias Restante Mês'} value={`${kpis.diasRestanteMes}`} />
      <KPIBox label={'Percentual Meta Mês'} value={`${data.PercentualMetaVenda[new Date(filtro.datainicial).getMonth()]?.toFixed(2)} %`} />

    </KPIContainer>
  );
}

export default KPISection;